
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'HumanFun',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/HumanFun.vue